<template>
    <div class="history_list_box">
        <HnDateSearch  :isPage="true" :defaultData="0" @update="dateUpdate" style="margin-top: 10px;" />
        <div class="echarts_box">
            <div id="echarts_box" style="width: 100%; height: 100%;" v-if="barData.length > 0"></div>
            <hnEmptyData  setType="col" size="80px" text="暂无统计数据" v-else></hnEmptyData>
        </div>
        <div class="table_box">
            <el-table :data="tableData" style="width: 100%" class="monitor-table" height="200">
             
                <el-table-column prop="alarmType" label="告警类型" align="center" width="120">
                    <template slot-scope="scope">  
                        <span class="sinleline alarm_content standbyColor">{{ $formatter(scope.row.alarmType,'alarmType') || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="alarmContent" label="告警内容" align="center">
                    <template slot-scope="scope">  
                        <div style="text-align: left;width: 100%;">{{ scope.row.alarmContent }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="alarmTime" label="时间" align="center" width="150"></el-table-column>
            </el-table>
        </div>
        <div class="pages_box" v-if="picTotal > 0">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="picFromInfo.pageIndex"
                :page-size="picFromInfo.pageSize" layout="total, prev, pager, next" class="pageInfo" background :total="picTotal">
              </el-pagination>
        </div>
    </div>
</template>

<script>
    import { optionMonitorPartnerPie } from "@/libs/echartsOption";
    export default {
        props:{
            devId:{
                type:String,
                default:''
            }
        },
        data(){
            return {
                date:[],
                picFromInfo:{
                    pageIndex:1,
                    pageSize:3,
                    devId:'',
                    sTime:'',
                    eTime:'',
                    timeType:0
                },
                picTotal:0,
                isPageShow:true,
                tableData: [],
                barData:[]
            }
        },
        
        methods:{
            echartInfo(dome, data) {
                let myChart = this.$echarts.init(document.getElementById(dome));

                myChart.setOption(optionMonitorPartnerPie(data), true);
                window.addEventListener("resize", function () {
                  myChart.resize();
                });
                // this.charts = myChart
            },
            dateUpdate(data){
                Object.assign(this.picFromInfo,data)
                this.getWarnInfo();
                this.getBarInfo()
            },
            handleCurrentChange(val) {
                this.picFromInfo.pageIndex = val;
                this.getWarnInfo();
                this.getBarInfo()
            },
            async getWarnInfo(){
              
                const res = await this.$api.LogGetDevCodeAlarmPageList(this.picFromInfo)
                console.log(res,'sdssssssssss')
                this.tableData = res ?.list || []
                this.picTotal = res ?.totalCount || 0;
           },
           async getBarInfo(){
                const res = await this.$api.LogDeviceAlarmStatistics(this.picFromInfo)
                console.log(res,'res')
                this.barData = res
                if(res.length > 0){
                    this.$nextTick(() => {
                      this.echartInfo('echarts_box', res)
                    })
                }
           }
           
        },
        mounted() {
            this.picFromInfo.devId = this.devId
            this.getWarnInfo()
            this.getBarInfo()
            // this.$nextTick(() => {
            //     let data = [
            //         {baseName: "气象站基地", liveStockNum: 12},
            //         {baseName: "自贡养殖基地", liveStockNum: 2}
            //     ]
               
            // })
        }
    }
</script>

<style lang="scss" scoped>
.history_list_box{
    height: 550px;
    display: flex;
    flex-direction: column;
    .echarts_box{
        height: 220px;
    }
    .table_box{
        flex: 1;
        min-height: 0px;
        margin-top: 10px;
        overflow: hidden;
        ::v-deep .el-table--border{
            border: none !important;
        }
        ::v-deep .el-table {
                border: none !important;
            }
            
            ::v-deep .el-table::before {
                display: none !important;
                background-color: none !important;
            }
          
        .monitor-table {
            ::v-deep .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #2c3e50;
                        color: #ffffff;
                        border: none !important;
                    }
                }
            }
           
            ::v-deep .el-table__body-wrapper {
                overflow-y: auto !important;
                .el-table__body {
                    td {
                        border: none !important;
                    }
                }
            }
            
            ::v-deep .el-table__border-line {
                display: none !important;
            }
            
            ::v-deep .el-table__body tr:hover > td {
                background-color: #34495e !important;
            }
            
            
        }
    }
    .pages_box {
        margin: 10px 0 ;
        text-align: right;
    }
}
</style>